import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LocalizedContentsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.ContentFilters>;
}>;


export type LocalizedContentsQuery = { contents: { edges?: Array<{ node: { id: string, isSyncedContentVerified?: boolean | null, sourceContentSyncedAt?: string | null, status: Types.ResourceStatusEnum } | { id: string, isSyncedContentVerified?: boolean | null, sourceContentSyncedAt?: string | null, status: Types.ResourceStatusEnum } | { id: string, isSyncedContentVerified?: boolean | null, sourceContentSyncedAt?: string | null, status: Types.ResourceStatusEnum } | { id: string, isSyncedContentVerified?: boolean | null, sourceContentSyncedAt?: string | null, status: Types.ResourceStatusEnum } | { id: string, isSyncedContentVerified?: boolean | null, sourceContentSyncedAt?: string | null, status: Types.ResourceStatusEnum } | {} }> | null } };


export const LocalizedContentsDocument = /*#__PURE__*/ gql`
    query localizedContents($filters: ContentFilters) {
  contents(filters: $filters) {
    edges {
      node {
        ... on CourseContentType {
          id
          isSyncedContentVerified
          sourceContentSyncedAt
          status
        }
        ... on QuizContentType {
          id
          isSyncedContentVerified
          sourceContentSyncedAt
          status
        }
        ... on ArticleContentType {
          id
          isSyncedContentVerified
          sourceContentSyncedAt
          status
        }
        ... on PathContentType {
          id
          isSyncedContentVerified
          sourceContentSyncedAt
          status
        }
        ... on SurveyContentType {
          id
          isSyncedContentVerified
          sourceContentSyncedAt
          status
        }
      }
    }
  }
}
    `;

export function useLocalizedContentsQuery(options?: Omit<Urql.UseQueryArgs<LocalizedContentsQueryVariables>, 'query'>) {
  return Urql.useQuery<LocalizedContentsQuery, LocalizedContentsQueryVariables>({ query: LocalizedContentsDocument, ...options });
};